export enum EChartCommand
{
    UpdateOnNextFrame = 1,
    AddPlot,
    ResizeChart,
}